<div class="map-container">
    <div id="map"></div>
</div>

<!-- Loading Spinner -->
<img class="progress-spinner rotate" *ngIf="loading" src="assets/loading.png" alt="loading...">
